import type { LayoutUpdatePayload, UserWidgetPreference, DashboardFetcher } from '../types';

/**
 * GET /api/dashboard/layout
 * Carga el layout guardado para el usuario autenticado.
 */
export const getUserLayout = async (
  userId: string,
  fetcher: DashboardFetcher
): Promise<UserWidgetPreference[]> => {
  return fetcher<UserWidgetPreference[]>('/api/dashboard/layout', { method: 'GET' });
};

/**
 * PUT /api/dashboard/layout
 * Reemplaza el layout completo del usuario (llamado con debounce 800ms).
 */
export const saveUserLayout = async (
  payload: LayoutUpdatePayload,
  fetcher: DashboardFetcher
): Promise<{ success: boolean }> => {
  return fetcher<{ success: boolean }>('/api/dashboard/layout', {
    method: 'PUT',
    body: payload,
  });
};
